const meta = require("./meta");
const ui = require("./ui");

module.exports = {
  meta,
  ui,
};
